function toLocalISOString(date = new Date()) {
  const pad = (n) => String(n).padStart(2, '0');

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());
  const ms = String(date.getMilliseconds()).padStart(3, '0');

  const offset = -date.getTimezoneOffset();
  const offsetSign = offset >= 0 ? '+' : '-';
  const offsetHours = pad(Math.floor(Math.abs(offset) / 60));
  const offsetMinutes = pad(Math.abs(offset) % 60);

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${ms}${offsetSign}${offsetHours}:${offsetMinutes}`;
}

document.querySelectorAll('.patient-mood-checks').forEach((el) => {
    let startTime = null;
    const startButton = el.querySelector('.start-button');
    const form = el.querySelector('form');

    startButton.addEventListener('click', () => {
        el.setAttribute('data-started', 'true');
        startTime = performance.now();
    });

    form.addEventListener('submit', (e) => {
        const durationInput = document.createElement('input');
        durationInput.type = 'hidden';
        durationInput.name = 'duration';
        durationInput.value = Math.round((performance.now() - startTime) / 1000);
        form.appendChild(durationInput);

        const localCreatedAtInput = document.createElement('input');
        localCreatedAtInput.type = 'hidden';
        localCreatedAtInput.name = 'local_created_at';
        localCreatedAtInput.value = toLocalISOString();
        form.appendChild(localCreatedAtInput);
    });
});
